import { useEffect, useState } from 'react';
import { useLoginContext } from '../../../../../App';
import useGettingWidgetData from '../../../hooks/useGettingWidgetData';
import useB2BTranslation from '../../../../b2b-common/hooks/useB2BTranslation';
import { Box } from '@mui/material';
import ORGANIZATION_AUE_PIECHART_WidgetLayout from './ORGANIZATION_AUE_PIECHART_WidgetLayout';

const ORGANIZATION_AUE_PIECHART_Widget = ({ widget, atPublicDashboard = false, password = null }) => {
    const { loginData } = useLoginContext();
    const { t } = useB2BTranslation('b2b-reporting');
    const { widgetData, loading } = useGettingWidgetData(widget, atPublicDashboard, password);
    const [orgAUE, setOrgAUE] = useState(null);
    useEffect(() => {
        if (!widgetData) return;
        setOrgAUE(widgetData?.widgetResponse?.plansImpact || []);
    }, [widgetData]);
    
    if (loading || !orgAUE || orgAUE.length === 0) {
        return (
            <Box className={'OrgAUEPieWidget-loading'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                <Box className={'OrgAUEPieWidget-loading-text'}>
                    {t('Loading...')}
                </Box>
            </Box>
        );
    }

    const data = orgAUE.map((aueItem, index) => {
        return {
            levelN_ItemId: aueItem.dtoReference.theOne.levelN_ItemId,
            indicatorUUIDs: aueItem.dtoReference.theMany.map(indicator => indicator.indicatorUUID),
        };
    });

    const size = widget?.widgetConfig?.extraFields?.size || 170;

    return (
        <Box className={'OrgAUEPie-container'} height={`${size}px`} width={`${size}px`}
            display={'flex'} justifyContent={'center'} alignItems={'center'}
        >
            <ORGANIZATION_AUE_PIECHART_WidgetLayout
                data={data}
                size={size}
                locale={widget?.widgetConfig?.extraFields?.locale || loginData.locale || 'es'}
            />
        </Box>
    );
}

export default ORGANIZATION_AUE_PIECHART_Widget;
